import { ProductCount, StripeAccount, StripePayout } from '@reg/shared/model';

/**
 * Model to hold a online sales summary
 */
export class OnlineSalesSummary {
    public available: number = 0;
    public isStripeAccountReused: boolean = false;
    public stripeAccountId: string;
    public stripeAccountType: string;
    public pending: number = 0;
    public payoutTotal: number = 0;
    public disputed: number = 0;
    public payouts: StripePayout[] = [];
    public products: ProductCount[] = [];

    public isExpress(): boolean {
        return this.stripeAccountType === StripeAccount.TYPE_EXPRESS;
    }

    public get total(): number {
        return (this.pending || 0) + (this.available || 0) + (this.payoutTotal || 0);
    }

    public deserialize(json: any): OnlineSalesSummary {
        this.isStripeAccountReused = json.isStripeAccountReused;
        this.stripeAccountId = json.stripeAccountId;
        this.stripeAccountType = json.stripeAccountType;

        if (json.stripe) {
            this.available = json.stripe.available;
            this.pending = json.stripe.pending;
            this.payoutTotal = json.stripe.payoutTotal;
            this.disputed = json.stripe.disputed ? json.stripe.disputed * -1 : null;
            const payouts: Object[] = json.stripe.payouts;

            if (payouts) {
                for (const payout of payouts) {
                    this.payouts.push(new StripePayout().deserialize(payout));
                }
            }
        }

        const products: Object[] = json.products;
        if (products) {
            for (const product of products) {
                this.products.push(new ProductCount().deserialize(product));
            }
        }

        return this;
    }
}
